import styled from 'styled-components'

import { colors } from '@/utils/styling/colors'

export const StopShowingLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`

export const StopShowingCheckbox = styled.input`
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: ${colors('brand')};
`
